import { render, staticRenderFns } from "./BusinessUnitTemplates.vue?vue&type=template&id=b8f13d72&scoped=true&"
import script from "./BusinessUnitTemplates.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitTemplates.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnitTemplates.vue?vue&type=style&index=0&id=b8f13d72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f13d72",
  null
  
)

export default component.exports